import mitt from 'mitt';
/**
 * A lightweight event bus instance created using the `mitt` library.
 * The `eventBus` provides a simple publish-subscribe mechanism for event handling,
 * allowing for the registration of event listeners and the dispatching of events.
 */
export const eventBus = mitt();
